import { z } from "zod";

export const ReadyCheck = z.object({ name: z.string(), ok: z.boolean(), ms: z.number(), error: z.string().optional() });
export const ReadyResponse = z.object({ ok: z.boolean(), checks: z.array(ReadyCheck) });
export type ReadyResponse = z.infer<typeof ReadyResponse>;

export const ApiError = z.object({
  error: z.object({ code: z.string(), message: z.string(), retryable: z.boolean() }),
});
export type ApiError = z.infer<typeof ApiError>;
